import React, { createContext, useState, useEffect } from 'react';

const ThemeContext = createContext();
const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(true);
  useEffect(() => {
    updateCssVariables(darkMode);
  }, [darkMode]);
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };
  const updateCssVariables = (isDarkMode) => {
    const root = document.querySelector(':root');
    root.style.setProperty('--bg-color', isDarkMode ? '#04041a' : '#c2c7f0');
    root.style.setProperty('--text-color', isDarkMode ? '#bcc2ef' : '#04041a');
    root.style.setProperty('--main-color', isDarkMode ? '#ff002f' : '#ff002f');
  };
  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext, ThemeProvider };